module.exports = __webpack_public_path__ + "img/stone7.4d374729.png";